type OriginalConfig = {
  slug: string;
  notionWorkName: string;
};

export const ORIGINALS: OriginalConfig[] = [
  { slug: "seeingdouble", notionWorkName: "라온의 남자" },
  { slug: "oneroomta-promo", notionWorkName: "원룸 조교님 마케팅" },
];

const ORIGINAL_SLUG_SET = new Set(ORIGINALS.map((o) => o.slug));

export function isOriginalSlug(slug: string | undefined): slug is string {
  return typeof slug === "string" && ORIGINAL_SLUG_SET.has(slug);
}

/**
 * @throws ORIGINALS 또는 ipSlugs 에 중복이 있으면
 * ORIGINALS 는 WORKS 노출 여부와 무관하게 Notion 싱크 대상만 관리하므로
 * ipSlugs(ORIGINALS_LIST) 와의 완전 일치는 요구하지 않는다.
 */
export function assertOriginalsParity(ipSlugs: readonly string[]): void {
  const originalSlugs = ORIGINALS.map((o) => o.slug);
  if (new Set(originalSlugs).size !== originalSlugs.length) {
    throw new Error("[originals] ORIGINALS 에 중복 slug 존재");
  }

  const ipSlugSet = new Set(ipSlugs);
  if (ipSlugSet.size !== ipSlugs.length) {
    throw new Error("[originals] ORIGINALS_LIST 에 중복 slug 존재");
  }
}
